var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6494 1.60913V1.60815C14.4015 2.71183 16.2352 3.6802 18.1348 4.50464V4.50562C19.8283 5.26475 21.5729 5.90342 23.3555 6.41772L24.1221 6.63062L24.1289 6.63257L24.3496 6.68823V13.656C24.3496 19.3995 21.4595 23.3574 18.5176 25.9011C17.0456 27.1738 15.5674 28.0858 14.4502 28.6785C13.8924 28.9744 13.4266 29.1896 13.0996 29.3298C12.9359 29.4 12.8075 29.4508 12.7217 29.4832C12.679 29.4992 12.6491 29.5096 12.6318 29.5154C12.6226 29.5185 12.6209 29.5195 12.625 29.5183C12.6268 29.5178 12.6352 29.5153 12.6475 29.5125C12.6511 29.5116 12.6569 29.5099 12.6641 29.5085L12.5771 29.532L12.4717 29.5691L12.376 29.5349C12.2247 29.4779 9.31885 28.3743 6.42871 25.8806C3.48543 23.3411 0.593752 19.3946 0.59375 13.656V6.68726L0.813477 6.63257L0.820312 6.63062C2.87023 6.08763 4.87283 5.38007 6.80957 4.51636L6.81055 4.51733C8.71394 3.69164 10.5512 2.721 12.3066 1.61499L12.3135 1.61108L12.4785 1.50366L12.6494 1.60913Z",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0034 19.0615C15.4082 19.241 15.771 19.5032 16.0684 19.8312C16.3658 20.1593 16.5913 20.5459 16.7304 20.9663",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93013 19.0615C9.52535 19.241 9.16259 19.5032 8.86516 19.8312C8.56774 20.1593 8.34223 20.5459 8.20312 20.9663",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 9.5463C15.714 9.84375 15.5731 10.1195 15.3708 10.3473C15.1685 10.5752 14.9115 10.7477 14.6239 10.8485L14.0586 11.0454",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8767 11.0454L10.3114 10.8485C10.0238 10.7477 9.76673 10.5752 9.56444 10.3473C9.36214 10.1195 9.22131 9.84375 9.15527 9.5463",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1751 12.1473L17.8389 12.7183C17.5968 13.1145 17.277 13.4577 16.8986 13.727C16.5203 13.9962 16.0914 14.1861 15.6377 14.2851",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6377 16.207C16.1079 16.2652 16.5593 16.4268 16.9596 16.6802C17.3599 16.9335 17.6992 17.2724 17.9531 17.6723L18.1751 18.0212",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29373 14.2851C8.84004 14.1861 8.41109 13.9962 8.03278 13.727C7.65447 13.4577 7.33463 13.1145 7.09255 12.7183L6.75635 12.1473",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75635 18.0212L6.97837 17.6723C7.23225 17.2724 7.57152 16.9335 7.97183 16.6802C8.37215 16.4268 8.82358 16.2652 9.29373 16.207",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6374 17.1585V13.9867C15.6374 13.8185 15.5706 13.6572 15.4516 13.5382C15.3327 13.4192 15.1713 13.3524 15.0031 13.3524H9.92829C9.76005 13.3524 9.5987 13.4192 9.47974 13.5382C9.36078 13.6572 9.29395 13.8185 9.29395 13.9867V17.1585C9.29395 17.9997 9.62811 18.8064 10.2229 19.4012C10.8177 19.996 11.6245 20.3302 12.4657 20.3302C13.3069 20.3302 14.1136 19.996 14.7084 19.4012C15.3032 18.8064 15.6374 17.9997 15.6374 17.1585ZM14.3687 13.3524H10.5626V12.0837C10.5626 11.579 10.7631 11.0949 11.12 10.7381C11.4769 10.3812 11.961 10.1807 12.4657 10.1807C12.9704 10.1807 13.4544 10.3812 13.8113 10.7381C14.1682 11.0949 14.3687 11.579 14.3687 12.0837V13.3524Z",
    stroke: "#151C2B",
    strokeWidth: 1.18665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThLogo);
export default __webpack_public_path__ + "static/media/th-logo.d8484870e372053a63a40735c6e548f7.svg";
export { ForwardRef as ReactComponent };